

export const Face = () => {
    return <img className="face" src="/profile/face.png" alt="" />
}
  
